import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

const values = [
  {
    id: "local",
    eyebrow: "OUR LOCAL",
    title: "ローカルの輝きを、",
    accent: "世界へ",
    body: "大分県臼杵市乙見に2.3haのかぼす園を経営し、発祥の地の伝統を守りながらオリジナルブランド「乙御KABOS」を生産。荒れた耕作放棄地を再生し、300年の歴史を次代へつなぐ情熱を持っています。",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/42040e0a075fb071b9efc23075eb2bad.webp",
    alt: "かぼす農園の風景",
  },
  {
    id: "local2",
    eyebrow: "",
    title: "かぼすの力",
    accent: "",
    body: "香りと酸味の真骨頂。土地の恵みが育む柑橘で、食卓に一滴の感動と笑顔をお届けします。",
    image: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dd77afb4-74ad-40e4-813f-3a536a399645_compressed_kabos.webp",
    alt: "かぼす園の風景",
  },
  {
    id: "talent",
    eyebrow: "OUR TALENT MANAGEMENT",
    title: "表現の力で、",
    accent: "人を動かす",
    body: "各種メディア出演、MC、司会など数多くの実績を持つタレントが所属。映像制作をはじめ、イベントの舞台裏まで、ローカルの魅力を世界に届ける表現と発信を担っています。",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/59cabcae56308982eb9d66d602c14760.png",
    alt: "イベントMC出演の様子",
  },
  {
    id: "talent2",
    eyebrow: "",
    title: "映像とトークの力",
    accent: "",
    body: "講演・トークショー、ロケ出演、映像制作。多彩な現場で、ローカルの物語を編集し発信し続けています。",
    image: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/a6f7c28c2fe3768dd60f7d49febd472d.png",
    alt: "映像制作・取材の様子",
  },
];

function Eyebrow({ children }: { children: string }) {
  return (
    <p
      className="text-xs md:text-sm font-bold tracking-[0.25em] text-[#025ab0] mb-4"
      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      {children}
    </p>
  );
}

const marqueeImages = [
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/c2e216ef27f90d8b313d166de422ac50.webp",
    alt: "タレントマネジメント事業",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/a6f7c28c2fe3768dd60f7d49febd472d.png",
    alt: "映像制作・インタビュー取材",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/59cabcae56308982eb9d66d602c14760.png",
    alt: "イベントMC",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/300482f856b3faec9b98faff48ca4beb.png",
    alt: "イベント出演",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/bc5fceed0aff8ba214628f60c4796387.png",
    alt: "講演・トークショー",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/0709570e8420c772f06086412af481ad.png",
    alt: "ロケ出演",
  },
];

const localMarqueeImages = [
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/42040e0a075fb071b9efc23075eb2bad.webp",
    alt: "かぼす農園の風景",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dd77afb4-74ad-40e4-813f-3a536a399645_compressed_kabos.webp",
    alt: "かぼす園の風景",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/23bf4adb196377faccc58c97bed306f7.webp",
    alt: "乙御KABOS",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/777ab2d7-d041-4a5c-8d64-9f7b617cc87f_compressed_kabo001.webp",
    alt: "臼杵市乙見の古木",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/bf7995d5-f425-4597-9dd5-e1a47005d69b_compressed_S__88252421.webp",
    alt: "乙御KABOSのかぼす",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/80fbe974-b27b-4c15-b785-797384ffe383_compressed_OL4.webp",
    alt: "かぼすを手に持つ",
  },
  {
    src: "https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/781670f8f3d78b3af9c34c2e78ab5210.webp",
    alt: "OLカンパニー・自然",
  },
];

export default function About() {
  const { ref, isVisible } = useScrollReveal();
  const localReveal = useScrollReveal();
  const talentReveal = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: '私たちについて' }]}>

      {/* Split Hero */}
      <section className="px-4 md:px-6 lg:px-10 mb-10">
        <div className="relative w-full h-[320px] sm:h-[400px] md:h-[500px] lg:h-[580px] overflow-hidden rounded-2xl">
          <div className="flex w-full h-full">
            {/* Left image */}
            <div className="w-1/2 h-full relative overflow-hidden">
              <img
                src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/781670f8f3d78b3af9c34c2e78ab5210.webp"
                alt="OL Company - Nature"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
            {/* Right image */}
            <div className="w-1/2 h-full relative overflow-hidden">
              <img
                src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/b20889b2f96a458239fbba2304f28fd2.webp"
                alt="OL Company - Talent Management"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/25" />
          {/* Center text */}
          <div ref={ref} className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${getRevealClass(isVisible)}`}>
            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-tight"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              About
            </h1>
            <p
              className="text-sm sm:text-base md:text-lg font-medium text-white mt-3 md:mt-4 tracking-wider"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              私たちについて
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-white rounded-2xl p-8 md:p-12 lg:p-16 space-y-12">
          {/* Intro */}
          <div className="max-w-3xl">
            <Eyebrow>WHAT WE DO</Eyebrow>
            <h2
              className="text-xl md:text-2xl font-bold text-gray-900 tracking-wide leading-snug mb-8"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              OLカンパニーとは？
            </h2>
            <div
              className="space-y-5 text-base md:text-lg font-medium text-gray-800 leading-[1.9]"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              <p>
                「LOCAL FIRST」を社訓に掲げる株式会社OLカンパニー。
                <br />
                OL＝OITA LOCALの頭文字です。
              </p>
              <p>
                大分県のローカルタレント・森祐作のマネジメントを目的とする個人事務所として設立され、今では大分の特産品かぼすの生産、販売も手掛けております。
              </p>
              <p>
                私たちは、大分の魅力を世界へ届けるために、いままでにない価値を創造しつづけます。
              </p>
            </div>
          </div>

          {/* Two pillars: Local + Entertainment */}
          <div className="border-t border-gray-100 pt-12 md:pt-14">
            <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
              <p
                className="text-xs md:text-sm font-bold tracking-[0.25em] text-[#025ab0] mb-4"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                OUR IDENTITY
              </p>
              <h2
                className="text-2xl md:text-3xl font-bold text-gray-900 tracking-wide leading-snug"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                ローカルとタレントマネジメント、<br className="hidden md:block" />ふたつの力で大分を世界へ。
              </h2>
            </div>

            {/* Floating banner */}
            <div className="relative w-full overflow-hidden mb-12 md:mb-14">
              <div className="flex w-max animate-marquee">
                {[...marqueeImages, ...marqueeImages].map((img, i) => (
                  <div
                    key={i}
                    className="w-[200px] sm:w-[240px] md:w-[280px] h-[140px] sm:h-[170px] md:h-[190px] shrink-0 mr-4 md:mr-6 overflow-hidden rounded-xl"
                  >
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Floating banner (reverse) */}
            <div className="relative w-full overflow-hidden mb-12 md:mb-14">
              <div className="flex w-max animate-marquee-reverse">
                {[...localMarqueeImages, ...localMarqueeImages].map((img, i) => (
                  <div
                    key={i}
                    className="w-[200px] sm:w-[240px] md:w-[280px] h-[140px] sm:h-[170px] md:h-[190px] shrink-0 mr-4 md:mr-6 overflow-hidden rounded-xl"
                  >
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Local pillar */}
            <div ref={localReveal} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16 md:mb-20 ${getRevealClass(localReveal.isVisible)}`}>
              <div className="w-full h-[340px] sm:h-[400px] lg:h-[440px] overflow-hidden rounded-2xl">
                <img
                  src={values[0].image}
                  alt={values[0].alt}
                  className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
                />
              </div>
              <div>
                <Eyebrow>{values[0].eyebrow}</Eyebrow>
                <h3
                  className="text-xl md:text-2xl font-bold text-gray-900 tracking-wide leading-snug mb-2"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {values[0].title}
                  <span className="text-[#025ab0]">{values[0].accent}</span>
                </h3>
                <p
                  className="text-sm md:text-base font-medium text-gray-700 leading-[2.1] tracking-wide mb-6"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {values[0].body}
                </p>
                <a
                  href="/farm"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#025ab0] hover:underline underline-offset-4 whitespace-nowrap"
                >
                  ファーム事業を見る
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>

            {/* Entertainment pillar */}
            <div ref={talentReveal} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center ${getRevealClass(talentReveal.isVisible)}`}>
              <div className="w-full h-[340px] sm:h-[400px] lg:h-[440px] overflow-hidden rounded-2xl lg:order-2">
                <img
                  src={values[2].image}
                  alt={values[2].alt}
                  className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
                />
              </div>
              <div className="lg:order-1">
                <Eyebrow>{values[2].eyebrow}</Eyebrow>
                <h3
                  className="text-xl md:text-2xl font-bold text-gray-900 tracking-wide leading-snug mb-2"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {values[2].title}
                  <span className="text-[#025ab0]">{values[2].accent}</span>
                </h3>
                <p
                  className="text-sm md:text-base font-medium text-gray-700 leading-[2.1] tracking-wide mb-6"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {values[2].body}
                </p>
                <a
                  href="/entertainment"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#025ab0] hover:underline underline-offset-4 whitespace-nowrap"
                >
                  タレントマネジメント事業を見る
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}